module.exports = __webpack_public_path__ + "img/content_make8.42737b06.png";